<div [class]="backgroudStyle">
  <div class="environment-status-container">
    <div class="environment-status-container__title">{{'MAINTENANCE.ENVIRONMENT_STATUS' | translate}}</div>
    <div [class]="backgroudStyleBtn">{{statusLabel}}</div>
  </div>
  <div class="environment-status-container__info" *ngIf="showLabelError">{{'MAINTENANCE.ENVIRONMENT_STATUS_ERROR_LABEL' | translate}}</div>
  <div class="environment-status-container__alert" *ngIf="isError" (click)="verifyService()">{{'MAINTENANCE.VERIFY_SERVICE' | translate}}</div>
</div>
